import { UserRole } from 'shared/types/userRole';
import {
  allow,
  createPermission,
  forbid,
} from '../basePermissionsManager';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionTranslationKeys } from '../translationKeys';
import { Permission, PermissionConfig } from '../types';

export interface EditUserParams {
  authorId: string;
  authorRole: UserRole;
  modifiedUserId: string;
  modifiedUserRole: UserRole;
}

export interface DeleteUserParams extends EditUserParams {}

function forbidEditMyself({
  authorId,
  modifiedUserId,
}: EditUserParams): Permission {
  if (authorId === modifiedUserId) {
    return forbid(PermissionTranslationKeys.ACTION_FORBIDDEN);
  }
  return allow();
}

function forbidEditClientAdmin({
  authorRole,
  modifiedUserRole,
}: EditUserParams): Permission {
  if (modifiedUserRole === UserRole.organizationAdmin) {
    return createPermission(
      DELETE_CLIENT_ADMIN_PERMISSIONS[authorRole],
      PermissionTranslationKeys.ACTION_FORBIDDEN
    );
  }
  return allow();
}

export const CREATE_USER_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

const DELETE_CLIENT_ADMIN_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: false,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

const EDIT_USER_PERMISSIONS: PermissionConfig = CREATE_USER_PERMISSIONS;
const DELETE_USER_PERMISSIONS: PermissionConfig = CREATE_USER_PERMISSIONS;

export const UserPermissionManager = PermissionManagerFactory.create<
  void,
  EditUserParams,
  DeleteUserParams
>({
  permissionConfigForCreate: CREATE_USER_PERMISSIONS,
  permissionConfigForEdit: EDIT_USER_PERMISSIONS,
  permissionConfigForDelete: DELETE_USER_PERMISSIONS,
  businessRulesForEdit: [forbidEditMyself, forbidEditClientAdmin],
  businessRulesForDelete: [forbidEditMyself, forbidEditClientAdmin],
});

